import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const ErrorContainer = styled.div`
  display: ${({ children }) => (!!children ? "flex" : "none")};
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  margin-top: 10px;
  margin-bottom: 30px;
  color: red;
  text-align: center;
`;

const SupportLink = styled.a`
  color: #209cee;
  text-decoration: underline;
  cursor: pointer;
`;

export default function Error({ children, showSupportLink = false }) {
  const { t } = useTranslation();

  return (
    <ErrorContainer>
      {children}
      {showSupportLink && (
        <>
          {" "}
          {t("views.popovers.support_hint")}
          <SupportLink
            href={"https://t.me/sixtamp"}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            {t("views.popovers.support_link")}
          </SupportLink>
        </>
      )}
    </ErrorContainer>
  );
}

